import { render } from "./generarturno.vue?vue&type=template&id=602ccd72&scoped=true"
import script from "./generarturno.vue?vue&type=script&lang=js"
export * from "./generarturno.vue?vue&type=script&lang=js"

import "./generarturno.vue?vue&type=style&index=0&id=602ccd72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602ccd72"]])

export default __exports__